const translations = {
  "en": {
    "Others": "Others",
    "Total": "Total",
    "View all": "View all"
  },
  "zh-tw": {
    "Others": "其他",
    "Total": "總計",
    "View all": "查看全部"
  }
};

export default translations;
